import { combineReducers } from 'redux';
import { BROKERBANS_INQ } from './types';
var brokerBansInq = function (state, action) {
    if (state === void 0) { state = { options: [], trans: {} }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case BROKERBANS_INQ:
            return payload;
        default:
            return state;
    }
};
export var SCOPE_NAME = 'INQ';
var INQ = combineReducers({
    brokerBansInq: brokerBansInq,
});
export default INQ;
